// Based on .env VITE_ENV_MODE
export const PRODUCTION_ENVS = ["staging", "platform"];
export const TEST_STAGING_ENV_MODE = "test";
export const TEST_DEV_ENV_MODE = "test-dev";
export const DEV_ENV_MODE = "development";

export type FlagName =
  | "FEATURE_TOUR"
  | "PHISHING_SIMULATIONS_CUSTOMER"
  | "INCIDENTS_V3"
  | "DASHBOARD_OVERVIEW_CUSTOMER"
  | "PHS_CAMPAIGN_DETAILS_CUSTOMER_LEVEL"
  | "PHS_CAMPAIGN_DETAILS_LURE_PREVIEW_CUSTOMER"
  | "PHS_CAMPAIGN_DETAILS_LURE_PREVIEW_MSP"
  | "PT_CUSTOMERS_NEW_DATA_TABLE"
  | "LINK_LOCK_REFACTOR"
  | "PHS_CUSTOMER_SEND_TEST_LURE"
  | "SAT_NEW_USERS_AUTO_ENROLLMENT";

type Config = {
  [K in FlagName]: {
    dev: boolean;
    testDev: boolean;
    testStaging: boolean;
    prod: boolean;
  };
};

export const FLAGS_CONFIG: Config = {
  FEATURE_TOUR: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  PHISHING_SIMULATIONS_CUSTOMER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/groups/titanhq/dev/scrum/-/epics/58
  INCIDENTS_V3: {
    dev: false,
    testDev: true,
    testStaging: false,
    prod: false,
  },
  DASHBOARD_OVERVIEW_CUSTOMER: {
    dev: true,
    testDev: true,
    testStaging: false,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1286
  PHS_CAMPAIGN_DETAILS_CUSTOMER_LEVEL: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1570
  PHS_CAMPAIGN_DETAILS_LURE_PREVIEW_CUSTOMER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1098
  PHS_CAMPAIGN_DETAILS_LURE_PREVIEW_MSP: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1179
  PT_CUSTOMERS_NEW_DATA_TABLE: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1521
  LINK_LOCK_REFACTOR: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1706
  PHS_CUSTOMER_SEND_TEST_LURE: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1278
  SAT_NEW_USERS_AUTO_ENROLLMENT: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
};
